import ColorPicker from './components/ColorPicker'
export default ColorPicker
